import { Table as AntTable } from 'antd';
import styled from 'styled-components';
import { TableProps } from './types';
import { colord } from 'colord';

export const TableWrapper = styled.div`
    position: relative;
    .ant-table-container {
        border: 1px solid ${(props) => props.theme.semantic.border};
        border-radius: 12px;
    }
`;

export const StyledHeaderBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledTable = styled(AntTable)<TableProps>`
    &.ant-table-wrapper {
        border-radius: 12px;
    }

    .ant-table {
        border-radius: 12px;
        background-color: ${(props) => props.theme.semantic.background};

        font-family:
            'SF Pro Display',
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            Roboto,
            'Helvetica Neue',
            Arial,
            'Noto Sans',
            sans-serif !important;
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 100% !important;
        letter-spacing: 0 !important;
        vertical-align: middle !important;
        color: ${(props) => props.theme.semantic.textPrimary};
    }
    .ant-table-content {
        border-radius: 12px;
    }

    .ant-table-thead > tr > th {
        font-weight: 500 !important;
        white-space: nowrap;
        background-color: ${(props) => props.theme.semantic.surface};
        color: ${(props) => props.theme.semantic.textPrimary};
    }
    .ant-table-tbody > tr > td {
        font-weight: 400 !important;
        white-space: nowrap;
    }

    .ant-table-column-sorters {
        border-left: none !important;
        border-right: none !important;
        width: 100%;
    }

    .ant-table-column:hover .ant-table-column-sorters {
        border-left-color: transparent !important;
        border-right-color: transparent !important;
    }

    .ant-table-cell::before {
        content: unset !important;
    }

    .ant-table-cell-fix-right {
        background-color: ${(props) => props.theme.semantic.background};
    }
    .ant-table-cell-fix-right-first::after {
        box-shadow: none !important;
        border-right: 1px solid ${(props) => props.theme.semantic.border};
    }
    .ant-table-row:nth-child(even) .ant-table-cell-fix-right {
        background-color: ${(props) => props.theme.semantic.backgroundLight};
    }

    .ant-table-row:nth-child(odd) .ant-table-cell-fix-right {
        background-color: ${(props) => props.theme.semantic.background};
    }

    .ant-table-row:not(.ant-table-row-selected):hover > td {
        background-color: inherit !important;
    }
    .ant-table-row-selected:has(input[type='checkbox']:not(:checked)) > td {
        background-color: inherit !important;
    }

    .ant-table-cell-fix-right:hover {
        background-color: ${(props) => props.theme.semantic.background};
    }

    .ant-table-cell.actions-cell {
        padding: 0 !important;
        text-align: center;
        vertical-align: middle;
    }

    .ant-table-tbody > tr.cursor-pointer:hover > td {
        background-color: ${(props) =>
            props.theme.semantic.primaryLight} !important;
    }
    .ant-table-container table tr th,
    .ant-table-container table tr td {
        border-right: none !important;
    }

    .ant-table-column-sorters {
        display: inline-flex;
        align-items: center;
        flex-direction: row-reverse;
    }

    .ant-table-column-sorters .ant-table-column-title {
        margin-left: 8px;
        margin-right: 0;
    }

    .ant-table-tbody > tr:nth-child(even) {
        background-color: ${(props) => props.theme.semantic.backgroundLight};
    }

    .ant-table-tbody > tr:nth-child(odd) {
        background-color: ${(props) => props.theme.semantic.background};
    }

    .ant-table-tbody > tr.ant-table-row-selected > td {
        background-color: ${(props) =>
            props.theme.semantic.primaryLight} !important;
        color: ${(props) => props.theme.semantic.onBackground} !important;
        transition: background-color 0.2s ease;
    }

    .ant-checkbox-label {
        font-weight: 400;
        font-size: 16px;
    }
    .ant-checkbox-inner {
        width: 24px;
        height: 24px;
        border-radius: 8px;
        border: 2px solid ${(props) => props.theme.semantic.border};
        background-color: ${(props) => props.theme.semantic.background};
        transition: all 0.3s ease;
    }
    .ant-checkbox-disabled .ant-checkbox-inner {
        border: 2px solid ${(props) => props.theme.semantic.border};
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
        position: absolute;
        display: table;
        border: solid white;
        border-width: 0 2px 2px 0;
        content: '';
        top: 40%;
        left: 50%;
        width: 6px;
        height: 12px;
        transform: translate(-50%, -50%) rotate(45deg);
    }

    .ant-checkbox-checked + .ant-checkbox-label,
    .ant-checkbox-label:hover {
        transition: all 0.3s ease;
        color: ${(props) => props.theme.semantic.primary};
    }

    .ant-checkbox:hover + .ant-checkbox-label {
        color: ${(props) => props.theme.semantic.primary};
    }

    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${(props) => props.theme.semantic.primary};
        border: 2px solid ${(props) => props.theme.semantic.primary};
    }
`;
